import { render, staticRenderFns } from "./home-essentials-a45.vue?vue&type=template&id=6988ae6d&"
import script from "./home-essentials-a45.vue?vue&type=script&lang=js&"
export * from "./home-essentials-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports